import { ComponentType } from 'react';
import { Cog8ToothIcon as Cog } from '@heroicons/react/24/outline';
import { CurrencyEuroIcon as CurrencyEuro } from '@heroicons/react/24/outline';
import { UsersIcon as Users } from '@heroicons/react/24/outline';
import { CreditCardIcon as CreditCard } from '@heroicons/react/24/outline';
import { QuestionMarkCircleIcon as QuestionMarkCircle } from '@heroicons/react/24/outline';
import { NewspaperIcon as Newspaper } from '@heroicons/react/24/outline';
import { EnvelopeIcon as Mail } from '@heroicons/react/24/outline';
import { LightBulbIcon as LightBulb } from '@heroicons/react/24/outline';

type MenuItemTitleKey =
  | 'settings'
  | 'pricing'
  | 'referral'
  | 'contact'
  | 'shareIdeas'
  | 'subscription'
  | 'documentation'
  | 'news';

const CHANGELOG_URL = 'https://feedback.teetsh.com/changelog';

export interface MenuItem {
  isExternal?: boolean;
  route: string;
  icon: ComponentType;
  title: MenuItemTitleKey;
}

export const reglageMenuItem: MenuItem = {
  route: '/settings',
  icon: Cog,
  title: 'settings',
};

export const tarifsMenuItem: MenuItem = {
  route: '/pricing',
  icon: CurrencyEuro,
  title: 'pricing',
};

export const parrainage: MenuItem = {
  route: '/settings/parrainage',
  icon: Users,
  title: 'referral',
};

export const contactUs: MenuItem = {
  route: '/settings/contact',
  icon: Mail,
  title: 'contact',
};

export const shareIdeas: MenuItem = {
  route: '/settings/contact',
  icon: LightBulb,
  title: 'shareIdeas',
};

export const souscription: MenuItem = {
  route: '/settings/subscription',
  icon: CreditCard,
  title: 'subscription',
};

export const documentation: MenuItem = {
  isExternal: true,
  route: 'https://teetsh.com/documentation/',
  icon: QuestionMarkCircle,
  title: 'documentation',
};

export const news: MenuItem = {
  isExternal: true,
  route: CHANGELOG_URL,
  icon: Newspaper,
  title: 'news',
};
